import type { JSX } from 'react';
import React from 'react';

import type { DailyStat, IDailyStats, TAttributionModel } from '@feathr/blackbox';
import { Table } from '@feathr/components';
import type { ListResponse } from '@feathr/rachis';

import type { IRowOutput } from './DailyStatsColumns';
import { DailyStatsColumns, getConversionsColumn } from './DailyStatsColumns';

import * as styles from './DailyStatsTable.css';

interface IProps {
  stats: ListResponse<DailyStat>;
  isPending: boolean;
  showSpend?: boolean;
  showConversions?: boolean;
  attributionModel?: TAttributionModel;
}

function DailyStatsTable({
  stats,
  isPending,
  showSpend = true,
  showConversions = true,
  attributionModel = 'full',
}: Readonly<IProps>): JSX.Element {
  const excludedFilters: string[] = [];
  if (!showSpend) {
    excludedFilters.push('spend', 'cpm', 'cpc', 'cpa');
  }
  const columns = DailyStatsColumns.filter((c) => !excludedFilters.includes(c.id!));
  if (showConversions) {
    columns.push(getConversionsColumn(attributionModel));
  }
  return (
    <Table<IDailyStats, IRowOutput>
      className={styles.tableWrapper}
      columns={columns}
      idKey={'id'}
      isLoading={isPending}
      items={stats.models.map((stat) => {
        return stat.toJS();
      })}
      manual={false}
      noDataText={'No Data'}
    />
  );
}

export default DailyStatsTable;
